/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum ReportingTimeBucket {
    Month = 0,
    Week = 1
}

export function ReportingTimeBucketFromJSON(json: any): ReportingTimeBucket {
    return ReportingTimeBucketFromJSONTyped(json, false);
}

export function ReportingTimeBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): ReportingTimeBucket {
    return json as ReportingTimeBucket;
}

export function ReportingTimeBucketToJSON(value?: ReportingTimeBucket | null): any {
    return value as any;
}

